import { PredominantDegree } from '@backrs_ui/common-ui';

type CollegeSize = 'Very Small' | 'Small' | 'Medium' | 'Large';

export const determineCollegeSize = (undergradEnrollment?: number): CollegeSize => {
  if (!undergradEnrollment) {
    return 'Very Small';
  }

  switch (true) {
    case undergradEnrollment > 20000:
      return 'Large';
    case undergradEnrollment > 5000:
      return 'Medium';
    case undergradEnrollment > 2000:
      return 'Small';
    default:
      return 'Very Small';
  }
};

export const determineDegreeType = (predominantDegree?: PredominantDegree): '4 year' | '2 year' => {
  if (!predominantDegree) {
    return '4 year';
  }

  if (predominantDegree === "Predominantly bachelor's-degree granting") {
    return '4 year';
  }

  return '2 year';
};

export const getRigorPercent = (
  rigor_level: number,
): { rigor: string; percent: 0 | 25 | 50 | 75 | 100 } => {
  switch (rigor_level) {
    case 3:
      return {
        rigor: 'Critically Important',
        percent: 100,
      };
    case 2:
      return {
        rigor: 'Very Important',
        percent: 75,
      };
    case 1:
      return {
        rigor: 'Important',
        percent: 50,
      };
    case 0:
      return {
        rigor: 'Less Important',
        percent: 25,
      };
    default:
      return {
        rigor: 'N/A',
        percent: 0,
      };
  }
};

export const getExtracurricularsPercent = (
  extracurriculars_level: number,
): { extracurriculars: string; percent: 0 | 25 | 50 | 75 | 100 } => {
  switch (extracurriculars_level) {
    case 4:
      return {
        extracurriculars: 'Exceptional',
        percent: 100,
      };
    case 3:
      return {
        extracurriculars: 'Very Strong',
        percent: 75,
      };
    case 2:
      return {
        extracurriculars: 'Strong',
        percent: 50,
      };
    case 1:
      return {
        extracurriculars: 'Typical',
        percent: 25,
      };
    case 0:
      return {
        extracurriculars: 'Weak',
        percent: 0,
      };
    default:
      return {
        extracurriculars: 'N/A',
        percent: 0,
      };
  }
};
